import { IMAGE_UPLOADER_FAILED, IMAGE_UPLOADER_REQUEST, IMAGE_UPLOADER_SUCCESS, S3_UPLOADER_FAILED, S3_UPLOADER_REQUEST, S3_UPLOADER_SUCCESS } from "../Actions/ImageUploader";

const InitialState = {
    loading: false,
    imageData: '',
    file_url: ''
};

export const ImageUploaderReducer = (state = InitialState, action: any) => {
    switch (action.type) {
        case IMAGE_UPLOADER_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case IMAGE_UPLOADER_SUCCESS:
            return {
                ...state,
                loading: false,
                imageData: action.payload
            };

        case IMAGE_UPLOADER_FAILED:
            return {
                ...state,
                loading: false,
                imageData: ''
            };

        case S3_UPLOADER_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case S3_UPLOADER_SUCCESS:
            return {
                ...state,
                loading: false,
                file_url: action.payload
            };

        case S3_UPLOADER_FAILED:
            return {
                ...state,
                loading: false,
                file_url: ""
            };

        default:
            return state;
    }
}